import * as api from './../../providers/actionCounter/userActionCounterProvider'
import { info } from './../../application/console'

export const FETCH_USER_STATS_FAILED = '[userStats] failed to fetch user stats'
export const FETCH_USER_STATS_SUCCESS = '[userStats] fetched user stats successfully'

// TODO: delete this mockApi when done.
const mockApi = {
  fetchUserActionCounter({ userId }) {
    info(`fetching ${userId} stats`)

    return new Promise(resolve => {
      resolve({
        postCreate: 104570,
        readsGot: 300,
        commentsGot: 400,
      })
    })
  },
}

function apiFactory() {
  // replace "true" with url params
  return true ? api : mockApi
}

export const fetchUserStats = id => dispatch => {
  const api = apiFactory()

  api
    .fetchUserActionCounter({ userId: id })
    .then(response => {
      if (typeof response.error !== 'undefined') {
        dispatch({ type: FETCH_USER_STATS_FAILED })
        return
      }

      dispatch({
        type: FETCH_USER_STATS_SUCCESS,
        response,
      })
    })
    .catch(() => dispatch({ type: FETCH_USER_STATS_FAILED }))
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/userStats/Stats.actions.js